import BN from 'bn.js';

export async function getAmountInDecimals(amount: any ,decimals: any) {
   const amountStr = amount.toString();
   // Split into integer and fractional parts
   const [integerPart, fractionalPart = ""] = amountStr.split(".");
   
   // If the fractional part has more digits than allowed, you can either throw an error
   // or truncate it. Here, we choose to truncate.
   let fractionalAdjusted = fractionalPart.length > decimals 
     ? fractionalPart.slice(0, decimals)
     : fractionalPart.padEnd(decimals, "0");
   
   // Combine the integer and adjusted fractional parts
   const combined = integerPart + fractionalAdjusted;
   
   // Create a BN instance from the combined string
   return new BN(combined);
}